// 配置编译环境和线上环境之间的切换
// const baseUrl = 'http://192.168.2.139:7503';//IP服
const baseUrl = 'https://api-dev.ynlctech.com' // 开发服
// const baseUrl = 'https://api-test.ynlctech.com'; //测试服
const senBaseUrl = 'http://47.108.203.157:8401' // 森客灵工测试服

// const baseUrl = "https://api.ynlctech.com";//正式服
// const senBaseUrl = '' // 森客灵工正式服

// let baseUrl = '/govt';
// const env = process.env
// if (env.NODE_ENV == 'development') {
//   baseUrl = ``; // 开发环境地址
// } else if (env.NODE_ENV == 'production') {
//   baseUrl = ``; //生产环境地址
// } else if (env.NODE_ENV == 'test') {
//   baseUrl = ``; //测试环境地址
// }
export {
  baseUrl,
  senBaseUrl
}